module.exports = __webpack_public_path__ + "static/media/img_logo_bem_querer.fe22567c.svg";